<!-- 底部固定按钮 【web时隐藏，移动端显示；图标（h40,w根据按钮个数自适应，内容居中）】  --> 

<template>
  <div class="btn-nav">
    <div class="btn-nav-item">
      <div class="btn-nav-icon" @click="callPhone">
        <i class="iconfont icon-business_a"  alt="现在拨打"></i>   
        <div class="btn-nav-text">现在拨打</div>
      </div> 
    </div>
    <!-- <div class="btn-nav-item">
      <div class="btn-nav-icon" @click="callPhone">
        <i class="iconfont icon-economy_a"  alt="经济舱拨打"></i>   
        <div class="btn-nav-text">经济舱拨打</div>
      </div> 
    </div> -->
    <div class="btn-nav-item">
      <div class="btn-nav-icon" @click="openTelegram">
        <i class="iconfont icon-telegram_r"></i>  
        <div class="btn-nav-text">加入Telegram群</div>
      </div> 
    </div>
  </div>

</template>

<script>
export default{
  methods:{
    callPhone(){
      
      var configs = this.$store.state.configs[0];
      var phone ='tel:' + configs.phone; 
      window.location.href = phone;
    },
    callLine(){
      window.location.href = 'https://line.me/ti/p/@4259-996494'
    },
    callWechat(){
      window.location.href = 'https://weixin.qq.com/'
    },
    openLineGroup(){
      window.location.href = 'https://line.me/ti/g/4259-996494'
    },
    openTelegram(){
      // var configs = this.$store.state.configs;
      var telegram = 'https://t.me/taotaosea'; //+configs[0].telegram; 
      window.location.href = telegram;
    }
  }
}
</script>

  
<style lang="scss" scoped>
@import '@/assets/iconfont/iconfont.css';
@import url(@/assets/css/commPage.scss);

  .btn-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    background:#020221; // #11191f;
    
    box-shadow: 0 -1px 5px rgba(0,0,0,0.1);
    opacity: 0.95;
    z-index: 999;
  }
  
  .btn-nav-item {
   flex: 1;
   text-align: center;
   padding: .3rem; 
   background: #040435;  
  }
  .btn-nav-item:last-child {
    border-right: none;
    margin-right: .3rem; 
  }

  .btn-nav-icon .iconfont{
    height: 30px;
    width: 30px;
    font-size: 30px;  
    color: #dfc680;
    // color: -webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
  }
  
  .btn-nav-icon img {
    height: 30px;
    width: auto;
  }
  
  .btn-nav-text {
    font-size: 14px; 
    padding: 5px 0 8px 0;
    color: #bfbfbf;
  }
  
  /* Web端隐藏 */
  @media (min-width: 768px) {
    .btn-nav {
      display: none;
    }
  }
</style>